import "./freeBoxes.css";
import { routes } from "../../routes";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../utils/GlobalConstants";
import { getFreeBoxes } from "../../api/modules/b2droppie.class";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";
import {ReactComponent as Boxes} from "../../assets/icons/boxes.svg";
const FreeBoxes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [freeBoxes, setFreeBoxes] = useState([]);
  const user = useSelector((state) => state?.auth?.user);
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  useEffect(() => {
    if (user?.free_boxes) {
      fetchFreeBoxes();
    }
  }, [user?.free_boxes]);

  const fetchFreeBoxes = async () => {
    setLoading(true);
    try {
      const response = await getFreeBoxes();
      setFreeBoxes(response?.data?.data?.boxes);
    } catch (err) {
      console.error("Error fetching transactions:", err);
    } finally {
      setLoading(false);
    }
  };

  const encryptData = (data) => {
    const base64EncodedData = window?.btoa(data?.toString());
    return base64EncodedData;
  };

  const handleClick = (slug) => {
    const boxNameEncrypt = encryptData(slug);
    navigate(`${routes.BOXDETAIL}/${boxNameEncrypt}`);
  };

  return (
    <>
      <div
        className={`fairness-header ${
          isDarkMode ? "fairness-header-dark dark" : "light"
        }`}
      >
        <div className="fairness-header-left">
          <div className="fairness-icon">
            <Boxes className="icon-filled-yellow"  style={{height:"48px",width:"48px"}}            />
          </div>
          <div className="fairness-header-text">
            <h1
              className={`fairness-title-header ${isDarkMode ? "text-white" : "text-deep-purple"}`}
            >
              Free Boxes
            </h1>
            <p className="fairness-subtitle-header text-light-gray">
              Claim your free boxes now to win excited prizes
            </p>
          </div>
        </div>
      </div>

      <div style={{ margin: isMobile ? "0px 0px" : "0px 23px" }}>
        <div
          className={`container free-box-outer mt-4 p-4 ${isDarkMode ? "dark" : "light"}`}
        >
          <div className="row">
            {freeBoxes?.length ? (
              freeBoxes?.map((item, index) => (
                <div
                  key={index}
                  className="col-sm-6 col-md-3 col-12 mb-4"
                  onClick={() => handleClick(item?.slug)}
                >
                  <div
                    className="free-box-card"
                    style={{ width: isMobile ? "100%" : "15rem" }}
                  >
                    <div className="d-center">
                      <img
                        alt={item?.name}
                        className="card-img-top"
                        src={item?.box_images?.image}
                      />
                    </div>
                    <div className="card-body pb-4">
                      <h5 className="card-title text-center text-light-gray mt-2">{item?.name}</h5>
                      <div className="mt-4">
                        <span className="filled-medium-deep-yellow-btn-dark px-5">
                          Free Box
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="d-center">No Free Boxes Available</div>
            )}
          </div>
        </div>
      </div>
      <BackdropLoader show={loading} />
    </>
  );
};

export default FreeBoxes;
